import { Pipe, PipeTransform } from '@angular/core';
import { AppService } from '../shared/services/app.service';
import { UtilService } from '../services/util.service';

@Pipe({
    name: 'mapvaluesummary',
    standalone: false
})
export class MapValueSummaryPipe implements PipeTransform {
    constructor(private appService: AppService, private utilService: UtilService) { }
    transform(data: any, json: any) {
        let _value ={};
        if(json){
            _value[json.name] = data;
        }
        let value = this.utilService.getValue(_value, json);
        return this.utilService.transformToDigit(value,json);
    }

    

}
